export type LogAttributes = Record<string, unknown>;

export enum LogLevel {
  ERROR = 'error',
  WARN = 'warn',
  INFO = 'info',
  DEBUG = 'debug',
}

export interface LogErrorOptions {
  /**
   * Forward this error to the `onErrorLogged` callback — an external service
   * such as Sentry. On by default; set to `false` for expected/low-signal
   * failure paths that aren't worth alerting on.
   */
  notifyExternally?: boolean;
}

export type OnErrorLogged = (message: string, attributes?: LogAttributes, rawError?: unknown) => void;

export interface ILogger {
  error(message: string, attributes?: LogAttributes, options?: LogErrorOptions): void;
  warn(message: string, attributes?: LogAttributes): void;
  info(message: string, attributes?: LogAttributes): void;
  debug(message: string, attributes?: LogAttributes): void;
}
